import '../node_modules/core-js/modules/web.dom-collections.iterator.js';

/**
 * This function creates an immutable queue.
 * Adding and removing items will return a new queue.
 */
function createImmutableQueue() {
  let entries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return {
    add(data, id) {
      const matchIndex = id ? entries.findIndex(entry => entry.id === id) : -1;
      const copy = [...entries];
      if (matchIndex > -1) {
        copy.splice(matchIndex, 1, {
          id: id,
          data
        });
      } else {
        if (id === undefined) {
          id = "queue-item-".concat(createImmutableQueue.counter);
          createImmutableQueue.counter++;
        }
        copy.push({
          id,
          data
        });
      }
      return createImmutableQueue(copy);
    },
    remove(id) {
      return createImmutableQueue(entries.filter(entry => entry.id !== id));
    },
    removeAll() {
      return createImmutableQueue();
    },
    entries
  };
}
createImmutableQueue.counter = 0;

export { createImmutableQueue };
